import React from "react";
import CheckCircleIcon from "../icons/CheckCircleIcon";
import "../styles/onboardingStepper.scss";

/**
 * OnboardingStepper — Vertical step tracker for onboarding flow
 * Figma: Stepper component (24654:6699)
 *
 * Steps: Pricing → Create an account → Payments → Setting an account
 * Completed steps: check icon + #737373 text (Regular)
 * Active step: filled circle + #fafafa text (SemiBold)
 * Upcoming steps: empty circle + #525252 text (Regular)
 *
 * @param {number} currentStep - 0-indexed active step
 */

const STEPS = [
  "Pricing",
  "Create an account",
  "Payments",
  "Setting an account",
];

const OnboardingStepper = ({ currentStep = 0 }) => {
  return (
    <div className="mango-stepper">
      {STEPS.map((label, index) => {
        const isCompleted = index < currentStep;
        const isActive = index === currentStep;

        return (
          <div key={label} className="mango-stepper__step-wrapper">
            {/* Connector line (not for first step) */}
            {index > 0 && (
              <div
                className={`mango-stepper__line ${
                  isCompleted || isActive ? "mango-stepper__line--active" : ""
                }`}
              />
            )}

            {/* Step item */}
            <div className="mango-stepper__step">
              <CheckCircleIcon
                size={32}
                active={isActive}
                color={isCompleted ? "#737373" : "#525252"}
              />
              <span
                className={`mango-stepper__label ${
                  isActive
                    ? "mango-stepper__label--active"
                    : isCompleted
                    ? "mango-stepper__label--completed"
                    : "mango-stepper__label--upcoming"
                }`}
              >
                {label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OnboardingStepper;
